/**
 * Extract a capitalised first name from an email for the Lobby greeting.
 *
 * Mirrors the prototype's rule:
 *   - Take the local-part (everything before `@`).
 *   - Split on `.`, `_`, `-`; keep the first chunk.
 *   - Capitalise the first character.
 *   - Fallback to "there" for empty / invalid input so we never render
 *     "Welcome back, <em>.</em>"
 *
 * Examples:
 *   "andrey.ognevsky@spaceti.com" → "Andrey"
 *   "x@y.z"                       → "X"
 *   "1@y.z"                       → "1"
 *   ""                            → "there"
 */
export function greetingName(email: string | null | undefined): string {
  const raw = (email ?? '').trim()
  if (!raw) return 'there'
  const local = raw.split('@')[0] ?? ''
  const first = local.split(/[._-]/)[0] ?? ''
  if (!first) return 'there'
  return first.charAt(0).toUpperCase() + first.slice(1)
}
